export const MENU_ITEM_ID_ORDER = 'Order'
export const MENU_ITEM_ID_OPEN_ORDER = 'OpenOrder'
export const MENU_ITEM_ID_UPLOAD_PART_FILE = 'UploadPartFile'
export const MENU_ITEM_ID_MY_ACCOUNT = 'MyAccount'
export const MENU_ITEM_ID_ADMIN = 'Admin'
export const MENU_ITEM_ID_ORDER_MANAGEMENT = 'OrderManagement'
export const MENU_ITEM_ID_POWER_USER = 'PowerUser'
export const MENU_ITEM_ID_SUBMITTED_ORDER = 'SubmittedOrder'
export const MENU_ITEM_ID_POINTS_AND_REWARDS = 'PointsAndRewards'
